export default "\r\n> [!INFO]\r\n> \r\n> tags:  #🕸️/ \r\n> References:   \r\n> Links: \r\n";